




































































import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import { Location } from "vue-router";
import EmployeesNavigation from "@/employer/components/user-management/EmployeesNavigation.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import ManageFundingFile from "@/employer/components/shared/ManageFundingFile.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import PageSizeSelectList from "@/shared/components/ui/PageSizeSelectList.vue";
import Pill from "@/shared/components/ui/Pill.vue";
import { CensusUploadStatus } from "@/employer/types";

import * as employeeNavigatorUrls from "@/shared/employeeNavigatorUrls";
import { useUserStore } from "@/shared/store/user";
import { useEmployeeIdUpdaterStore } from "@/employer/store/employeeIdUpdater";

@Component({
  components: {
    EmployeesNavigation,
    ManageFundingFile,
    Pagination,
    PageSizeSelectList,
    Pill,
    GenericLoadingSpinner
  }
})
export default class EmployeeIdUpload extends Vue {
  EmployeeNavigatorUrls = employeeNavigatorUrls;

  userStore = useUserStore();
  employeeIdUpdaterStore = useEmployeeIdUpdaterStore();

  @Prop()
  page: number;

  @Prop()
  routeToEmployeeIdFileUploadView: (page: number) => Location;

  mounted (): void {
    this.employeeIdUpdaterStore.loadFileList({
      employerId: this.employerId,
      pageNumber: this.page
    });
    this.$on("refreshFileUpload", () => {
      this.employeeIdUpdaterStore.reloadFileList(this.employerId);
      if (this.page !== 1) {
        this.$router.push(this.routeToEmployeeIdFileUploadView(1));
      }
    });
  }

  get employerId (): number {
    if (this.userStore.currentEmployer && this.userStore.currentEmployer.employerId) {
      return this.userStore.currentEmployer.employerId;
    }
    return 0;
  }

  @Watch("page")
  onRouteValuePageNumberChanged (): void {
    this.employeeIdUpdaterStore.loadFileList({
      employerId: this.employerId,
      pageNumber: this.page
    });
  }

  getPillClass (status: CensusUploadStatus): string {
    switch (status) {
      case CensusUploadStatus.Pending: {
        return "neutral-pill";
      }
      case CensusUploadStatus.Fail: {
        return "error-pill";
      }
      case CensusUploadStatus.SomeErrors: {
        return "warning-pill";
      }
      default: {
        return "success-pill";
      }
    }
  }

  hasErrorFile (status: CensusUploadStatus): boolean {
    if (status === CensusUploadStatus.Fail || status === CensusUploadStatus.SomeErrors) {
      return true;
    }
    return false;
  }

  getStatusText (status: CensusUploadStatus): string {
    switch (status) {
      case CensusUploadStatus.NoErrors: {
        return "No Errors";
      }
      case CensusUploadStatus.SomeErrors: {
        return "Some Errors";
      }
      default: {
        return status;
      }
    }
  }

  downloadFile (employeeIdFileId: number) {
    this.employeeIdUpdaterStore.downloadFileResult({ employerId: this.employerId, fileId: employeeIdFileId });
  }

  switchPageSize (): void {
    this.$router.push(this.routeToEmployeeIdFileUploadView(1));
    this.employeeIdUpdaterStore.reloadFileList(this.employerId);
  }

  switchPage (toPage): void {
    this.$router.push(this.routeToEmployeeIdFileUploadView(toPage));
  }

  tableFields = [
    {
      key: "uploaded",
      label: "Uploaded",
      thClass: "text-left pl-2",
      tdClass: "pl-2 color-primary"
    },
    {
      key: "fileName",
      label: "File name",
      thClass: "text-left",
      tdClass: "text-left color-primary"
    },
    {
      key: "error",
      label: "",
      thClass: "text-center",
      tdClass: "text-center color-primary"
    },
    {
      key: "uploadStatus",
      label: "Status",
      thClass: "text-center",
      tdClass: "text-center color-primary"
    },
    {
      key: "updated",
      label: "Updated",
      thClass: "text-right",
      tdClass: "text-right color-primary"
    }
  ];
}
